import React, { useState } from "react";
import { Link } from "react-router-dom";
import Banner from "../../assets/images/banner.svg";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import LogOut from "../../assets/images/Logout.svg";
import axios from "axios";
import Tooltip from "@mui/material/Tooltip";
import LogoutIcon from "@mui/icons-material/Logout";
import { Logout } from "@mui/icons-material";
function TopBar() {
  const description = {
    typography: {
      "@media (max-width: 600px)": {
        fontSize: "16px",
      },
    },
  };

  const SERVER_URI = process.env.REACT_APP_SERVER_URI;
  const GET_USER = `${SERVER_URI}/user`;
  const AUTHENTIK_LOGIN_URL = `${SERVER_URI}/ssologin`;
  const LOGOUT = `${SERVER_URI}/logout`;

  const [name, setName] = useState("");
  const [res, setRes] = useState([]);
  React.useEffect(() => {
    let token = localStorage.getItem("accessToken");
    let config = {
      headers: { Authorization: `Bearer ${token}` },
    };
    if (res.length === 0) {
      axios
        .get(GET_USER, config)
        .then((response) => {
          setRes(response.data.user);
          setName(response.data.user.name);
          // Remove the setEmail and setSelectedImage lines
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, []);

  const checkout = async () => {
    let token = localStorage.getItem("accessToken");
    let config = {
      headers: { Authorization: `Bearer ${token}` },
    };
    try {
      await axios.post(LOGOUT, {},config, { withCredentials: true });
      localStorage.clear();
      sessionStorage.clear()
      setTimeout(() => {
        window.location.href = "/user_Login";
      }, 100);
    } catch (error) {
      console.error("Error logging out:", error);
    }
  };

  return (
    <div>
      <Box
        sx={{
          padding: "20px",
          display: "flex",
          justifyContent: "space-between",
          backgroundColor: "#fff",
        }}
      >
        <Link to="/">
          <img src={Banner} alt="" width={100} />
        </Link>
        <Box
          sx={{
            display: "flex",
            gap: "20px",
            alignItems: "center",
            "@media (max-width: 576px)": {
              flexDirection: "column-reverse",
            },
          }}
        >
          {/* <Typography sx={{
  fontFamily: 'Poppins',
  ...description.typography,
  fontSize: '18px',
  fontWeight: 400,
  lineHeight: '18px',
  letterSpacing: '0em',
  textAlign: 'center',
}}
>
        Hello, &nbsp;{name}
      </Typography> */}
          <Tooltip title="Logout">
            <button
              onClick={checkout}
              style={{
                fontFamily: "Roboto Flex",
                backgroundColor: "transparent",
                border: "none",
                cursor: "pointer",
              }}
            >
              <LogoutIcon sx={{ color: "red" }} />
            </button>
          </Tooltip>
        </Box>
      </Box>
    </div>
  );
}

export default TopBar;
